module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "title"
  }, [_vm._v("Сотрудники " + _vm._s("(" + _vm.items.length + ")") + " ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "brown lighten-1",
    attrs: {
      "fab": "",
      "small": "",
      "dark": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.reloadData()
      }
    }
  }, [_c('v-icon', [_vm._v("refresh")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "deep-orange darken-1",
    attrs: {
      "fab": "",
      "small": "",
      "dark": "",
      "title": "Добавить сотрудника в команду"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.add($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', [_vm._l((props.headers), function(header, index) {
          return _c('th', {
            key: header.text,
            class: ['column', 'subheading', index === 0 ? 'text-xs-left' : 'text-xs-center']
          }, [_vm._v("\n                  " + _vm._s(header.text) + "\n                ")])
        }), _vm._v(" "), _c('th')], 2)]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-center body-2"
        }, [_vm._v(" " + _vm._s(props.item.id) + " ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center body-2"
        }, [_vm._v(" " + _vm._s(props.item.nick_name) + " ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center body-2"
        }, [_vm._v(" " + _vm._s(props.item.check_count) + " ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center body-2"
        }, [_vm._v(" " + _vm._s(props.item.balance) + " ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center body-2"
        }, [_vm._v(" " + _vm._s(props.item.paid_until) + " ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-center body-2"
        }, [_vm._v(" " + _vm._s(props.item.paid_count) + " ")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('v-btn', {
          staticClass: "teal",
          attrs: {
            "fab": "",
            "small": "",
            "flat": "",
            "title": "Передать подписку сотруднику"
          },
          nativeOn: {
            "click": function($event) {
              _vm.subscribe(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("repeat")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "fab": "",
            "small": "",
            "flat": "",
            "title": "Удалить сотрудника из команды"
          },
          nativeOn: {
            "click": function($event) {
              _vm.remove(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('confirm-dialog', {
    attrs: {
      "dialog": _vm.dialog,
      "dialogTitle": _vm.dialogTitle,
      "dialogText": _vm.dialogText
    },
    on: {
      "onConfirm": _vm.onConfirm,
      "onCancel": _vm.onCancel
    }
  }), _vm._v(" "), _c('confirm-dialog', {
    attrs: {
      "dialog": _vm.dialogSubscribe,
      "dialogTitle": _vm.dialogSubscribeTitle,
      "dialogText": _vm.dialogSubscribeText
    },
    on: {
      "onConfirm": _vm.onConfirmSubscribe,
      "onCancel": _vm.onCancelSubscribe
    }
  }), _vm._v(" "), (_vm.snackbar) ? _c('v-snackbar', {
    attrs: {
      "right": true,
      "timeout": _vm.timeout,
      "color": _vm.mode
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.notice) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeSnackbar($event)
      }
    }
  }, [_vm._v("Close")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/vue-loader/lib/template-compiler?{"id":"data-v-880ebc94","hasScoped":false}!/Users/gtirby/develop/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/WorkerList.vue
// module id = 420
// module chunks = 0